<template>
  <div class="pages">
    <img src="/static/other/banner-lx@3x.png" class="bImg" />
    <div class="b_pic_text">
      {{ $t('main.contactUs') }}
    </div>
    <div class="content" id="scroll-box">
      <div class="cu_title" :id="contactInfo.id">
        <div>{{ contactInfo.name }}</div>
        <img src="/static/other/icon_right.png" class="cImg" />
      </div>
      <div class="facab" style="margin-top: 3.75rem;">
        <div class="cbox">
          <img src="/static/other/icon_rx.png" class="first" />
          <div class="second">{{ $t('main.serviceHotline') }}</div>
          <div class="third"><span style="font-weight: bold;">{{ $t('main.salesHotline') }}</span>：{{ $t('main.salesHotlineTel') }}</div>
          <div class="forth"><span style="font-weight: bold;">{{ $t('main.telephoneExchange') }}</span>：{{ $t('main.telephoneExchangeTel') }}</div>
        </div>
        <div class="cbox">
          <img src="/static/other/icon_yx.png" class="first" />
          <div class="second">{{ $t('main.businessCooperation') }}</div>
          <div class="third">{{ $t('main.companyFax') }}：{{ $t('main.faxNum') }}</div>
          <div class="forth">{{ $t('main.businessMail') }}：<a :href="'mailto:'+$t('main.emailAddress')+'?subject='+$t('main.emailSubject')">{{ $t('main.emailAddress') }}</a></div>
        </div>
        <div class="cbox">
          <img src="/static/other/icon_js.png" class="first" />
          <div class="second">{{ $t('main.technicalSupport') }}</div>
          <div class="third" v-html="$t('main.technicalSupportTel')"></div>
        </div>
      </div>
      <div class="cu_title">
        <div>{{ $t('main.feedback') }}</div>
        <img src="/static/other/icon_right.png" class="cImg" />
      </div>
      <div class="cont" style="margin: 2.75rem 0;">
        <div class="fac fk">
          <el-form ref="report" :model="reportInfo" inline>
            <el-form-item class="is-required" prop="email" :label="$t('main.email')">
              <el-input
                  :placeholder="$t('main.pleaseEnter')"
                  v-model="reportInfo.email"
                  clearable
              ></el-input>
            </el-form-item>
            <el-form-item class="is-required" prop="content" :label="$t('main.FeedbackContent')">
              <el-input
                  :placeholder="$t('main.pleaseEnter')"
                  v-model="reportInfo.content"
                  clearable
                  style="width: 480px !important;"
              ></el-input>
            </el-form-item>
            <el-button class="tjBtn" @click="handleReport">{{ $t('main.commit') }}</el-button>
          </el-form>
        </div>
      </div>
      <div class="cu_title">
        <div>{{ $t('main.onlineService') }}</div>
        <img src="/static/other/icon_right.png" class="cImg" />
      </div>
      <div class="kf">
        <el-row v-if="isCN" :gutter="12">
          <el-col :span="8" v-for="item in peopleList">
            <el-card class="box-card" shadow="always">
              <div class="text item">
                <i class="el-icon-user"></i>
                {{item.name}}
              </div>
              <div class="text item">
                <i class="el-icon-mobile-phone"></i>
                {{ item.url }} (微信同号)
              </div>
            </el-card>
          </el-col>
        </el-row>

        <el-row v-if="!isCN" :gutter="12">
          <el-col :span="6" v-for="item in peopleList">
            <a :href="'skype:' + item.url +'?chat'" target="_blank">
              <el-card style="text-align: center;" class="box-card" shadow="always">
                <div class="text item">
                  <img style="width:14px;" src="/static/home/skype.png"/>
                  {{item.name}}
                </div>
              </el-card>
            </a>
          </el-col>
        </el-row>

      </div>
      <div class="cMap"  v-html="contactInfo.content"></div>
      <div v-for="item in steps" :key="item.id">
        <div v-if="item.list_template === 'category_join'">
          <join :steps="steps" :info="item" :id="item.id"></join>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import join from "./components/join";
import {categoryread, reportApi} from "@/api";
import Cookies from "js-cookie";
import {
  getBlokcList
} from "@/api";
export default {
  components: {
    join
  },
  data() {
    return {
      steps: [],
      peopleList: [],
      offsetTop: 0,
      reportInfo: {
        email: "",
        content: ""
      },
      contactInfo: []
    };
  },
  props: ["isCN"],
  watch: {
    "$store.state.siteInfo": function() {
      this.getContactInfo();
      this.getPeopleList();
    },
    "$store.state.tabs": function() {
      this.getContactInfo();
      this.getPeopleList();
    }
  },
  created() {
    this.getContactInfo();
    this.getPeopleList();
  },
  methods: {
    handledJump() {
      this.steps = [];
      if (localStorage.getItem("navTabs_" + Cookies.get("siteInfo"))) {
        let tabs = this.treeToArray(JSON.parse(localStorage.getItem("navTabs_" + Cookies.get("siteInfo"))));
        let nowNav = tabs.find(item => {
          if (item.identification) {
            return this.$route.params.identification == item.identification;
          } else {
            return this.$route.params.identification == item.id;
          }
        });
        if (nowNav && nowNav.pid == '0') {
          this.steps = tabs.filter(item => {
            return item.pid == nowNav.id
          });
        } else if (nowNav) {
          this.steps = tabs.filter(item => {
            return item.pid == nowNav.pid
          });
        }
        if(this.steps.length && nowNav.pid != '0') {
          this.$nextTick(() => {
            setTimeout(() => {
              this.jump(nowNav.id);
            }, 500);
          });
        }
      }
    },
    handleReport() {
      let params = {
        req: {
          ...this.reportInfo,
          content_id: 0,
          site_id: Cookies.get("siteInfo"),
          product_id: 0
        }
      };
      reportApi(params).then(res => {
        if (res.rsp.code === 0) {
          this.$message({
            message: this.$t('main.operationCompletedSuccessfully'),
            type: "success"
          });
          this.reportInfo = {
            email: "",
            content: ""
          };
        } else {
          this.$message({
            message: res.rsp.msg,
            type: 'error'
          })
        }
      });
    },
    getContactInfo() {
      if (localStorage.getItem("navTabs_" + Cookies.get("siteInfo"))) {
        let tabs = this.treeToArray(JSON.parse(localStorage.getItem("navTabs_" + Cookies.get("siteInfo"))));
        let item = tabs.find(item => item.name == this.$t('main.contactUs') && item.pid !== '0');
        if (!item) {
          item = tabs.find(item => item.name == this.$t('main.contactUs') && item.pid === '0');
        }
        if (item) {
          let params = {
            "req": {
              "id": item.id
            }
          }
          categoryread(params).then((res)=>{
            this.contactInfo = res.data;
            this.handledJump();
          })
        }
      }
    },
    treeToArray(data) {
      let res = [];
      function auxiliary(arr) {
        arr.forEach(item => {
          let obj = {
            id: item.id,
            pid: item.pid,
            model_id: item.model_id,
            is_menu: item.is_menu,
            is_post: item.is_post,
            name: item.name,
            image: item.image,
            identification: item.identification,
            list_template: item.list_template,
            article_template: item.article_template,
            child:null
          };
          // 如果是产品则添加 list_template 和 article_template
          if (item.model_id == 23 && item.pid == 0) {
            obj.list_template = 'category_product';
            obj.article_template = 'detail_product';
          }
          if (item.model_id == 23 && item.pid != 0) {
            obj.list_template = 'category_product_more';
            obj.article_template = 'detail_product';
          }

          res.push(obj);
          if (item.child && item.child.length) {
            auxiliary(item.child);
          }
        });
      }
      if (data) {
        auxiliary(data);
      }
      return res;
    },
    getPeopleList(){
      let params = {
        "req": {
          "page": 1,
          "where": [
            {
              "condition": "2",
              "filed": "type",
              "expression": "="
            },
            {
                "condition": Cookies.get("siteInfo"),
                "filed": "site_id",
                "expression": "="
            }
          ],
          "limit": 20,
          "order": "orderby desc"
        }
      };
      getBlokcList(params).then(res => {
        if(res.rsp.code === 0) {
            this.peopleList = res.data.list;
            this.handledJump();
        }
      });
    },
    jump(id) {
      let scrollItem = document.getElementById(id);
      if (scrollItem) {
        // 锚点对应的模块与最近的一个具有定位的祖宗元素顶部的距离
        this.offsetTop = scrollItem.offsetTop;
        window.scrollTo({
          top: scrollItem.offsetTop,
          behavior: "smooth"
        });
      }
    }
  }
};
</script>

<style scoped lang="less">
.pages {
  .bImg {
    width: 100%;
  }
  .b_pic_text {
    position: relative;
    bottom: 9rem;
    margin: 0 auto -4.8rem;
    font-family: YouSheBiaoTiHei,serif;
    font-size: 3.5rem;
    font-weight: 400;
    text-align: center;
    font-style: italic;
    color: white;
    background-color: rgba(0,0,0,.5);
    border-radius: 0.5rem;
  }
  .content {
    .cu_title {
      margin-top: 3.25rem;
      font-size: 1.875rem;
      font-family: YouSheBiaoTiHei,serif;
      font-weight: 400;
      color: #666666;
    }
    .cImg {
      width: 1.625rem;
      height: 0.5rem;
      margin-top: 1.25rem;
    }
    .cbox {
      min-width: 30%;
      min-height: 20.625rem;
      background: #fafafa;
      text-align: center;
      border-radius: 0.5rem;
      .first {
        width: 1.875rem;
        height: 1.875rem;
        margin-top: 5.5rem;
      }
      .second {
        font-size: 1.1428rem;
        color: #1a1a1a;
        margin-top: 2.5rem;
      }
      .third {
        color: #999999;
        margin-top: 2.5rem;
      }
      .forth {
        color: #999999;
        margin-top: 1rem;
      }
    }
    .cMap {
      margin-top: 3.75rem;
      width: 100%;
      height: 100%;
      background-color: #fafafa;

      ::v-deep iframe{
        border-radius: 1rem;
      }
    }
    .fk {
      /deep/ .el-input__inner {
        border: 0px;
        border-bottom: 1px solid #d8d9dc;
        background-color: #fff;
      }
    }

    .tjBtn {
      width: 86px;
      height: 32px;
      background: #635796;
      border-radius: 4px;
      color: #fff;
      padding: 0;
    }
    .kf {
      margin: 2.75rem 0;
      ::v-deep .el-card {
        margin: 0 0 10px 0;
      }
      ::v-deep .el-card__body,
      ::v-deep .el-main {
        padding: 10px 20px;
      }
    }
  }
  @media screen and (max-width: 1400px) {
    .content {
      padding: 0 2% 3.25rem;
    }
  }
  @media screen and (min-width: 1400px) {
    .content {
      padding: 0 10% 3.25rem;
    }
  }
  @media screen and (min-width: 1700px) {
    .content {
      padding: 0 15% 3.25rem;
    }
  }
}
</style>
